import { useAuth0 } from '@auth0/auth0-react';
import { useAtomValue } from 'jotai';
import { useCallback } from 'react';

import { getMailingsContaining } from '@/apis/mailings';
import { DomainCode, domainCodeAtom } from '@australiangreens/ag-internal-components';
import { createChipLabelText, createChipTooltip } from '@/util';
import { labelSorting } from '@/util/labelSorting';

export const useLookupMailing = () => {
  const { getAccessTokenSilently } = useAuth0();
  const domainCode = useAtomValue(domainCodeAtom);
  return useCallback(
    async (lookupValue: string) => {
      const token = await getAccessTokenSilently();
      return (await getMailingsContaining(token, lookupValue, domainCode as DomainCode))
        .map(({ id, name, scheduledDate = '' }) => {
          const chipTooltipText = createChipTooltip(name, scheduledDate);
          const chipLabel = createChipLabelText(name, scheduledDate);
          return {
            id: id,
            chipLabel: chipLabel,
            label: chipTooltipText,
            tooltipContent: chipTooltipText,
          };
        })
        .sort(labelSorting);
    },
    [domainCode, getAccessTokenSilently]
  );
};
